// v3.7B — shared avatar with quiet-luxury initials fallback.
import React, { useState } from 'react';

const SIZES = { xs: 'w-7 h-7 text-xs', sm: 'w-9 h-9 text-sm', md: 'w-12 h-12 text-lg', lg: 'w-20 h-20 text-2xl', xl: 'w-28 h-28 text-4xl' };

export const Avatar = ({ src, name, size = 'md', className = '', testId = 'avatar' }) => {
  const [broken, setBroken] = useState(false);
  const initials = (name || '·').trim().slice(0, 1).toUpperCase();
  const cls = SIZES[size] || SIZES.md;
  const url = src && !broken
    ? (src.startsWith('/api/') ? `${window.__SG_API_BASE__}${src}` : src)
    : null;
  return (
    <span
      data-testid={testId}
      className={`${cls} rounded-full flex-shrink-0 overflow-hidden flex items-center justify-center bg-[#0D0D0D] text-[#C7A96B] font-serif border border-[#E5E4E2] ${className}`}>
      {url ? (
        <img src={url} alt={name || 'Profile'} className="w-full h-full object-cover"
          onError={() => setBroken(true)} data-testid={`${testId}-img`} />
      ) : (
        <span aria-hidden data-testid={`${testId}-initials`}>{initials}</span>
      )}
    </span>
  );
};

export default Avatar;
